import React, { useContext, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  useToast,
  Flex,
  Box,
} from "@chakra-ui/react";
import { useHistory, useParams } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";
import { PurchasesContext } from "../Context/PurchasesContext";
import { BiDetail } from "react-icons/bi";
import moment from "moment";
import TdType from "../Common/Table/TdType";
import ActionModal from "../Common/ActionModal";
import useFetch from "../../hooks/useFetch";
import CustomTBody from "../Common/Table/CustomTBody";
import { createSkeleton } from "../../Utils/utils";
import { numberFormatter } from "../../Utils/formatUtils";
import Pagination from "../Common/Layout/Pagination";

function PurchasesTable() {
  const {
    purchases,
    getPurchases,
    isLoadingPurchases,
    maxPagination,
    currentPage,
    setPagination,
  } = useContext(PurchasesContext);
  const [selectedPurchase, setSelectedPurchase] = useState({});
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const { del } = useFetch();
  const history = useHistory();
  const toast = useToast();

  let params = useParams().state;

  const calculateTotal = (products) => {
    let total = 0;

    products.map((product) => {
      total += product.cost * product.qty;
    });

    return total;
  };

  const handleDelete = () => {
    del(`/suppliers/purchases/${selectedPurchase.id}`)
      .then(() => {
        toast({
          title: "Eliminar compra",
          description: "Se eliminó la compra con éxito.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        getPurchases();
      })
      .catch((e) => {
        toast({
          title: "Se ha producido un error.",
          description:
            e?.message || "Contacte con el administrador del sistema.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const createRows = () => {
    let formattedRows = purchases.map((purchase) => {
      return [
        {
          item: <TdType text={purchase.id} />,
        },
        {
          item: (
            <TdType text={moment(purchase.purchasedAt).format("DD-MM-YYYY")} />
          ),
        },
        {
          item: <TdType text={purchase.businessName} />,
        },
        {
          item: (
            <TdType text={numberFormatter(calculateTotal(purchase.products))} />
          ),
        },
        {
          item: <TdType text={purchase.status} />,
        },
        {
          item: <TdType text={purchase.comments} />,
        },
        {
          tdStyle: { textAlign: "center" },

          item: (
            <>
              <Icon
                as={BiDetail}
                _hover={{
                  cursor: "pointer",
                }}
                title="Detalle"
                fontSize="1.5em"
                onClick={() =>
                  history.push(`/compras/${purchase.id}`, {
                    prevPath: params,
                  })
                }
              ></Icon>
              <Icon
                as={FiTrash2}
                _hover={{
                  cursor: "pointer",
                }}
                title="Eliminar"
                fontSize="1.5em"
                ml="10px"
                onClick={() => {
                  setIsDeleteModalOpen(true);
                  setSelectedPurchase(purchase);
                }}
              ></Icon>
            </>
          ),
        },
      ];
    });
    return formattedRows;
  };

  const handleSelectedPage = (page) => {
    setPagination(page);
  };

  return (
    <>
      <Box overflowX={"scroll"} pb={"0.5rem"}>
        <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
          <Thead>
            <Tr>
              <Th fontSize="0.8em">Nro. Compra</Th>
              <Th fontSize="0.8em">Fecha </Th>
              <Th fontSize="0.8em">Proveedor</Th>
              <Th fontSize="0.8em">Total ($)</Th>
              <Th fontSize="0.8em">Estado</Th>
              <Th fontSize="0.8em" width="30%">
                Observaciones
              </Th>
              <Th fontSize="0.8em" textAlign="center">
                Acciones
              </Th>
            </Tr>
          </Thead>
          {isLoadingPurchases ? (
            <CustomTBody rows={[createSkeleton(7)]} />
          ) : purchases.length ? (
            <CustomTBody rows={createRows()} />
          ) : (
            <Tbody>
              <Tr>
                <Td colSpan="100%">
                  <Box padding="1rem 0">No se encontraron resultados</Box>
                </Td>
              </Tr>
            </Tbody>
          )}
        </Table>
      </Box>
      <Flex justifyContent={"center"} py={"2rem"}>
        <Pagination
          max={maxPagination}
          currentPage={currentPage}
          handleSelectedPage={handleSelectedPage}
        />
      </Flex>
      <ActionModal
        isOpen={isDeleteModalOpen}
        setIsOpen={setIsDeleteModalOpen}
        deleteItem={selectedPurchase}
        action={handleDelete}
        title={"Eliminar compra"}
        text={`¿Desea borrar la compra ${selectedPurchase.id}?`}
        actionButtonText={"Borrar"}
      ></ActionModal>
    </>
  );
}

export default PurchasesTable;
